import React, { useEffect, useState } from 'react'
import { EmptyCollection, TableListComp } from '../../../../shared_elements'
import { globalGetService } from '../../../../globalServices'
import { checkApiStatus, dateTransform, getCurrencyFormat } from '../../../../utils_v2'
import { Paper, TableCell, TableRow } from '@material-ui/core'
import { displayDateFormat, displayDateFormatShort } from '../../../../constants'
import { AttachmentsRow } from '../../../../lease_management/lease_details/components'
import NumericLabel from 'react-pretty-numbers';

import moment from 'moment'
const expHd = [
    { label: 'Type', sortOption: false },
    { label: 'Insurance Number', sortOption: false },
    { label: 'Insurer', sortOption: false },
    { label: 'Insuree', sortOption: false },
    { label: 'Policy Period', sortOption: false },
    { label: 'Amount (USD)', sortOption: false },
    { label: 'Attachment(s)', sortOption: false },
  ];
  
const ExpList = ({item}) => {
  return (
    <TableRow hover tabIndex={-1} style={{position:'relative'}} >
      <TableCell>{item.insurance_type.label}</TableCell>
      <TableCell>{item.insurance_number}</TableCell>
      <TableCell>{item.insurer}</TableCell>
      <TableCell>{item.insuree}</TableCell>
      <TableCell>
        {item.policy_start_date ? moment(item.policy_start_date).format(displayDateFormatShort):''}
        -
        {item.policy_end_date ? moment(item.policy_end_date).format(displayDateFormatShort):''}
      </TableCell>
      <TableCell>{item.insurance_amount? <NumericLabel params={getCurrencyFormat()}>{item.insurance_amount}</NumericLabel>:'--'}</TableCell>
       <TableCell>{item?.attachments?.length> 0 ?<AttachmentsRow attachmentsData={item?.attachments}/>:"--"}</TableCell> 
      </TableRow>
  )
}
export default function ExpirationLeaseCertificate({props}) {
  const [expList, setExpList] = useState([])
  useEffect(() => {
    getExpList()
  }, [])
  const getExpList = () => {
    globalGetService(`contracts/${props?.params?.contract_slug}/insurances/`,)
      .then(response => {
        if (checkApiStatus(response)) {
          setExpList(response.data.data)
        }
      })
  }
  return (
      <Paper className='exp-insurance'>
      <h5 className="para">Insurance Certificate(s)</h5>
      <TableListComp
        heads={expHd}
        blueHd='true'
        data={expList?.map(item=> 
          <ExpList 
          item={item}/>
        )}
        height={!expList?.length ?'420px':null}
        noRecord={expList?.length ? null :
              <EmptyCollection
                  title="No records found"
              />
      }
      />
      </Paper>
  )
}
